import type { SupabaseKeySource } from '../observability';

export type SupabaseKeyResolution = { key: string; source: SupabaseKeySource };

export function resolveServiceRoleSupabaseKey(): SupabaseKeyResolution {
  if (process.env.SUPABASE_SECRET_KEY) return { key: process.env.SUPABASE_SECRET_KEY, source: 'SUPABASE_SECRET_KEY' };
  return { key: 'fake-supabase-key', source: 'unset' };
}

export function resolveAnonSupabaseKey(): SupabaseKeyResolution {
  if (process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY)
    return { key: process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY, source: 'NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY' };
  return { key: 'fake-supabase-key', source: 'unset' };
}
